import { toastMessage } from "./toastMessage";
import { postAddItem } from "./addItem";
import { preventFormsInteraction } from "./../preventFormsInteraction";

try {
  const addItemFormEls = document.querySelectorAll("[data-shop-item]");

  const amountsChange = (data, fieldsetEls = null) => {
    let previousCount = data.count;

    if (data) {
      preventFormsInteraction(fieldsetEls, true);

      postAddItem(data, () => {
        previousCount = data.count;
        preventFormsInteraction(fieldsetEls, false);
      });
    }
  };

  addItemFormEls.forEach((addItemFormEl) => {
    addItemFormEl.addEventListener("submit", (e) => {
      e.preventDefault();
      const d = new FormData(addItemFormEl);
      const addItemFormFieldsetEls = addItemFormEl.querySelectorAll("fieldset");
      const formData = {
        count: d.get("anzahl"),
        token: d.get("_token"),
        sku: d.get("artikelnummer"),
      };

      amountsChange(formData, addItemFormFieldsetEls);
    });
  });

  const basketFormFieldsetEls = document.querySelectorAll("[data-shop-basket] fieldset");
  const basketItemEls = document.querySelectorAll("[data-shop-basket] [data-basket-item]");
  basketItemEls.forEach((basketItemEl) => {
    const triggerEl = basketItemEl.querySelector('[name="anzahl"]');

    triggerEl.addEventListener("change", () => {
      const countInputEl = basketItemEl.querySelector('[name="anzahl"]');
      const tokenInputEl = basketItemEl.querySelector('[name="_token"]');
      const skuInputEl = basketItemEl.querySelector('[name="artikelnummer"]');

      if (countInputEl && tokenInputEl && skuInputEl) {
        const formData = {
          count: countInputEl.value,
          token: tokenInputEl.value,
          sku: skuInputEl.value,
        };
        amountsChange(formData, basketFormFieldsetEls);
      }
    });
  });
} catch (error) {}

document.addEventListener("addItem:failure", () => {
  toastMessage("Das Hinzufügen eines Artikels zum Warenkorb war nicht erfolgreich.");
});
